<template>
  <a-result
      status="403"
      sub-title="Nie masz dostępu do tej strony!"
      title="403"
  >
  </a-result>
</template>
<script>
export default {
  name: "Error403",
  data() {
    return {};
  },
  mounted() {
    this.$emit("loadedView");
  },
};
</script>
